module.exports = {
  jersies: [
    'product_31',
    'product_33',
    'product_35',
    'product_37',
    'product_30',
    'product_32',
    'product_34',
    'product_36',
    'product_38',
  ],
  shorts: [
    'product_47',
    'product_49',
    'product_51',
    'product_53',
    'product_55',
    'product_48',
    'product_50',
    'product_52',
    'product_54',
    'product_56',
  ],
  baselayers: ['product_72', 'product_73', 'product_66', 'product_67'],
};



// WEBPACK FOOTER //
// ./utils/products.js